import { Reveal } from "../motion/Reveal";
import { AnimatedText } from "../motion/AnimatedText";

export const SectionHead = ({ label, title, desc, light = false, align = "left" }) => (
  <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
    <Reveal>
      <p className={`label flex items-center gap-3 ${align === "center" ? "justify-center" : ""} ${light ? "text-cream-50/50" : "text-ink-500"}`}>
        <span className={`inline-block h-px w-8 ${light ? "bg-cream-50/40" : "bg-ink-400"}`} />
        {label}
      </p>
    </Reveal>
    <h2
      className={`mt-4 text-3xl font-bold leading-[1.15] tracking-tight sm:text-4xl lg:text-[2.75rem] ${
        light ? "text-cream-50" : "text-ink-900"
      }`}
    >
      <AnimatedText text={title} delay={0.05} />
    </h2>
    {desc && (
      <Reveal delay={0.18}>
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${light ? "text-cream-50/65" : "text-ink-500"}`}>
          {desc}
        </p>
      </Reveal>
    )}
  </div>
);
